import { render, staticRenderFns } from "./AsymptomaticAttestation.vue?vue&type=template&id=01cbc896&"
import script from "./AsymptomaticAttestation.vue?vue&type=script&lang=ts&"
export * from "./AsymptomaticAttestation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports